import { render, staticRenderFns } from "./ModalTickets.vue?vue&type=template&id=9a536554&scoped=true"
import script from "./ModalTickets.vue?vue&type=script&lang=js"
export * from "./ModalTickets.vue?vue&type=script&lang=js"
import style0 from "./ModalTickets.vue?vue&type=style&index=0&id=9a536554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a536554",
  null
  
)

export default component.exports